enum RoleEnum {
  ADMIN_MASTER,
  ADMIN,
  EDITOR,
  READER,
}

export { RoleEnum };
